// Keep long product grids visible on first render; observing the whole grid
// can leave every product below the visibility threshold until the shopper scrolls.
const revealSelector = [
  '.pantera-showcase__intro',
  '.pantera-showcase__products',
  '.pantera-editorial__head',
  '.pantera-editorial__grid',
  '.pantera-panels__inner',
  '.pantera-locations__header',
  '.pantera-locations__grid',
  '.pantera-benefits__intro',
  '.pantera-benefits__list',
  '.pantera-social__copy',
  '.pantera-social__panel',
  '.pantera-seo-content__intro',
  '.pantera-seo-content__trust',
  '.pantera-testimonials__header',
  '.pantera-testimonials__grid',
  '.pantera-black-trust__inner',
  '.pantera-payments__copy',
  '.pantera-payments__methods',
  '.pantera-collection-view__hero',
  '.pantera-collection-view__chips',
  '.pantera-product-detail__media',
  '.pantera-product-detail__info',
  '.pantera-cart__items',
  '.pantera-cart__summary',
].join(',');

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const setupMotion = () => {
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) return;

  const root = document.documentElement;
  root.dataset.panteraMotion = prefersReducedMotion.matches ? 'reduced' : 'enabled';

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.dataset.panteraReveal = 'visible';
        currentObserver.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08,
    }
  );

  const reveal = (target) => {
    if (target.hasAttribute('data-pantera-reveal')) return;

    target.dataset.panteraReveal = '';

    [...target.children]
      .filter((child) => !['SCRIPT', 'STYLE'].includes(child.tagName))
      .slice(0, 6)
      .forEach((child, index) => {
        child.dataset.panteraRevealChild = '';
        child.style.setProperty('--pantera-reveal-delay', `${index * 70}ms`);
      });

    observer.observe(target);
  };

  const scan = (scope = document) => {
    if (scope.matches?.(revealSelector)) reveal(scope);
    scope.querySelectorAll?.(revealSelector).forEach(reveal);
  };

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  prefersReducedMotion.addEventListener('change', ({ matches }) => {
    root.dataset.panteraMotion = matches ? 'reduced' : 'enabled';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupMotion, { once: true });
} else {
  setupMotion();
}
